import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const verificationGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.getUser();

  // If not logged in, allow auth guard to handle it
  if (!user) {
    return true;
  }

  // If verified, allow access
  if (user.verified) {
    return true;
  }

  // If not verified, redirect to verification page
  return router.createUrlTree(['/verification'], {
    queryParams: { returnUrl: state.url }
  });
};
